import { getDomainConfig } from '@/config/domains/domainConfig'

export const getDomainForCountry = (country: string): string => {
  const domainConfig = getDomainConfig()
  for (const domain in domainConfig) {
    if (domainConfig[domain].configurations.some(i => i.country === country)) {
      return domain
    }
  }

  throw new Error(`"${country}" is not supported`)
}